import { LineChart } from "@mui/x-charts/LineChart";
import { ChartCard } from "../../../components/charts/ChartCard";
import { CHART_COLORS, chartSx, formatRupees, formatRupeesAxis } from "../../../components/charts/chartTheme";
import { MonthlyFeeTrend } from "../types"; //The Key Concept: Barrel Files. ./types is treated as ../types/index.ts

export const MonthlyFeeTrendChart = ({ data }: { data: MonthlyFeeTrend[] }) => {
  return (
    <ChartCard title="Monthly Collection & Discounts">
      <LineChart
        height={300}
        dataset={data}
        xAxis={[{ scaleType: "point", dataKey: "month", disableTicks: true }]}
        yAxis={[{ width: 56, disableLine: true, disableTicks: true, valueFormatter: formatRupeesAxis }]}
        series={[
          { dataKey: "collected", label: "Collected", color: CHART_COLORS.series1, curve: "monotoneX", showMark: false, valueFormatter: formatRupees },
          { dataKey: "discount", label: "Discount", color: CHART_COLORS.series2, curve: "monotoneX", showMark: false, valueFormatter: formatRupees },
        ]}
        grid={{ horizontal: true }}
        margin={{ top: 10, right: 20, bottom: 0, left: 0 }}
        slotProps={{ legend: { position: { vertical: "top", horizontal: "end" } } }}
        sx={chartSx}
      />
    </ChartCard>
  );
};
